module.exports = __webpack_public_path__ + "img/logo_top.3f0b6bde.svg";